export default __webpack_public_path__ + "static/media/pdf-logo.ae610047.jpg";